var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ring"},_vm._l((3),function(index){return _c('div',{key:index,style:(("border-color: " + _vm.colorLoader + " transparent transparent transparent"))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }